module.exports = __webpack_public_path__ + "img/feicheng.c7b211ad.png";